// extracted by mini-css-extract-plugin
export default {"head":"head__LWCR4ASw"};